<template>
	<div>
		<v-card>
			<v-card-title>
				<v-btn icon @click="newEntry" class="ml-0 mr-3">
					<v-icon>add_circle</v-icon>
				</v-btn>

				<v-text-field
					v-model="search"
					label="Поиск"
					clearable
					class="mb-4"
					single-line
					hide-details>
				</v-text-field>

				<v-btn small :color="!filtersApplied ? 'primary' : 'secondary'" @click="showFilter" class="ma-2">
					{{ filtersApplied ? 'Сбросить фильтры' : filter ? 'Скрыть фильтры' : 'Показать фильтры' }}
				</v-btn>

			</v-card-title>

			<v-container class="pa-1" v-if="pool.length">
				<v-row>
					<v-col cols="6">
						<v-list dense>
							<v-list-item>
								<v-list-item-content>Общая сумма коррекции</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ poolTotal }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>Сумма выручки</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ poolRevenueTotal }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>Сумма расходов</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ poolExpensesTotal }}
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-col>
					<v-col cols="6">
						<v-row>
							<v-col class="text-right">
								<v-hover>
									<div slot-scope="{ hover }">

										<v-tooltip left :value="hover && !poolValid">
											<template v-slot:activator="{ on }">
												<v-btn
													small
													color="primary"
													class="mr-4"
													@click="submit"
													:loading="submitLoading"
													:disabled="!poolValid || submitLoading"
												>
													Отправить коррекцию
												</v-btn>
											</template>
											<span>Для отправки коррекции, все три суммы слева должны быть нулевыми</span>
										</v-tooltip>
									</div>
								</v-hover>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="text-right">
								<v-btn
									small
									color="secondary"
									class="mr-4"
									@click="clear"
								>
									Сбросить коррекцию
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>

			<v-data-table
				:headers="headers"
				:items="data"
				:items-per-page="-1"
				:loading="loading"
				hide-default-footer
				hide-default-header
				:mobile-breakpoint="0"
				show-expand
				single-expand
				no-data-text=""
				:expanded.sync="expanded"
				@click:row="clickRow"
				item-key="id">
				<template v-slot:header="props">
					<thead>
						<tr v-if="filter">
							<th></th>
							<th v-for="header in headers"
								:key="header.value"
								class="pa-0"
							>
								<template v-if="header.filterable && header.filterType == 'text'">
									<v-row align-content="center" justify="center">
										<v-col cols="12" class="px-5 pt-0">
											<v-text-field
												v-model="header.filterValue"
												:label="header.text"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable>
											</v-text-field>
										</v-col>
									</v-row>
								</template>

								<template v-if="header.filterable && header.filterType == 'number'">
									<v-row align-content="center" justify="center">
										<v-col cols="6" class="pl-5 pt-0 pr-1" >
											<v-text-field
												label="От"
												v-model="header.filterValue.from"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable
												>
											</v-text-field>
										</v-col>
										<v-col cols="6" class=" pr-5 pt-0 pl-1" >
											<v-text-field
												label="До"
												v-model="header.filterValue.to"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable
												>
											</v-text-field>
										</v-col>
									</v-row>
								</template>
							</th>
						</tr>
						<tr v-else>
							<th></th>
							<th	v-for="header in headers"
								:key="header.value"
								class="text-center">
									{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item="props">
					<tr
						@click="clickRow(props.item)"
						@mouseover="mouseover(props.item)"
						@mouseleave="mouseleave(props.item)"
					>
						<td :class="'text-center ' + tdClass(props.item.statusText)">
							<v-icon v-if="props.item.statusText != 'Draft'">
								{{ isExpanded(props.item) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
							</v-icon>
						</td>
						<td :class="'text-center ' + tdClass(props.item.statusText)">{{ props.item.year }}</td>
						<td :class="'text-center ' + tdClass(props.item.statusText)">{{ props.item.mon }}</td>
						<td :class="'text-center ' + tdClass(props.item.statusText)">{{ props.item.dcn }}</td>
						<td :class="'text-center ' + tdClass(props.item.statusText)">{{ props.item.icn }}</td>
						<td :class="'nowrap text-right ' + tdClass(props.item.statusText)">
							<strong v-if="highlight.indexOf(props.item.id) + 1">
								{{ props.item.value }}
							</strong>
							<span v-else>
								{{ props.item.value }}
							</span>
						</td>
						<td :class="'nowrap text-center ' + tdClass(props.item.statusText)">
							<strong v-if="props.item.statusText == 'Draft'">{{ props.item.statusText }}</strong>
							<span v-else>{{ props.item.statusText }}</span>
						</td>
						<td :class="'nowrap text-center ' + tdClass(props.item.statusText)">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="props.item.statusText == 'Draft'"
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="edit(props.item)">
							            edit
							        </v-icon>
								</template>
								<span>Редактировать</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="copy(props.item)">
							            file_copy
							        </v-icon>
								</template>
								<span>Копировать</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="props.item.statusText == 'Draft'"
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="del(props.item)">
							            delete
							        </v-icon>
								</template>
								<span>Удалить</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="!search && !filtersApplied && props.item.statusText != 'Draft'"
										small
										v-on="on"
										class="mr-2"
										@click.stop="delCorrection(props.item)">
							            delete_sweep
							        </v-icon>
								</template>
								<span>Удалить коррекцию</span>
							</v-tooltip>
						</td>
					</tr>
				</template>
				<template v-slot:expanded-item="props">
					<td :colspan="props.headers.length" class="pa-0">
				        <v-card tile dark>
							<v-row class="ma-0">
								<v-col cols="6">
						            <v-list dense>
										<v-list-item>
											<v-list-item-content>Дата записи</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ props.item.reportedAt }}
											</v-list-item-content>
										</v-list-item>
						              	<v-list-item>
							                <v-list-item-content>Автор</v-list-item-content>
							                <v-list-item-content class="align-end">
												{{ props.item.reportedBy }}
											</v-list-item-content>
						            	</v-list-item>
						              	<v-list-item>
							                <v-list-item-content>Комментарий</v-list-item-content>
							                <v-list-item-content class="align-end">
												{{ props.item.comment }}
											</v-list-item-content>
						            	</v-list-item>
									</v-list>
								</v-col>
							</v-row>
				        </v-card>
					</td>
			    </template>
				<template v-slot:body.append="{ headers }">
					<tr>
						<td colspan="5" class="nowrap text-left">
							Итого
						</td>
						<td class="nowrap text-right">
							{{ total }}
						</td>
						<td colspan="2"></td>
					</tr>
				</template>
			</v-data-table>
		</v-card>
		<v-dialog
			v-model="dialog.show"
			persistent
			max-width="1200">
			<v-card>
				<v-card-title>
					{{ dialog.new ? 'Создание коррекции' : 'Корректировка коррекции' }}
				</v-card-title>
				<v-form ref="f" v-model="dialog.valid">
		          	<v-card-text>
		            	<v-container>
		              		<v-row  justify="start">
								<v-col cols="6">
									<v-subheader v-if="!!poolYear && !!poolMon">Коррекция может включать проводки только в рамках одного периода</v-subheader>
									<v-subheader v-else>Месяц</v-subheader>
									<v-date-picker
										v-model="dialog.item.month"
										type="month"
										landscape
										required
										reactive
										locale="ru-ru"
										:disabled="!!poolYear && !!poolMon"
										:show-current="false"
										full-width>
									</v-date-picker>

								</v-col>
								<v-col cols="6">
									<v-row>
										<v-col cols="12">
				                  			<v-autocomplete
												v-model="dialog.item.dc"
												:items="dc"
												:rules="[rules.required]"
												item-value="code"
												item-text="name"
												@change="getIc"
												label="Отдел">
											</v-autocomplete>
				                		</v-col>
				                		<v-col cols="12">
											<v-autocomplete
												v-model="dialog.item.ic"
												:items="ic"
												:rules="[rules.required]"
												item-value="code"
												item-text="name"
												label="Статья">
											</v-autocomplete>
				                		</v-col>
				                		<v-col cols="12">
				                  			<a-number-field
												v-model="dialog.item.value"
												validate-on-blur
												:rules="[rules.required]"
												label="Сумма">
											</a-number-field>
				                		</v-col>
				                		<v-col cols="12">
				                  			<v-textarea
												v-model="dialog.item.comment"
												validate-on-blur
												label="Комментарий">
											</v-textarea>
				                		</v-col>
									</v-row>
								</v-col>

		              		</v-row>
		            	</v-container>
		          	</v-card-text>
				</v-form>

		        <v-card-actions>
					<v-btn
						text
						@click="add"
						:loading="dialog.loading"
						:disabled="!dialog.valid || dialog.loading"
						v-if="dialog.new">
						Добавить
					</v-btn>
					<v-btn
						text
						@click="save"
						:loading="dialog.loading"
						:disabled="!dialog.valid || dialog.loading"
						v-else>
						Сохранить
					</v-btn>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
</style>

<script>
	import aNumberField from '../base/ANumberField.vue'
	import {toStr, toNum} from '../../js/common.js'
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
			aNumberField
		},
		props: {
			hotelCode: String
		},
		data: () => ({
			headers: [
				{
					text: 'Год',
					value: 'year',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Месяц',
					value: 'mon',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Отдел',
					value: 'dcn',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Статья',
					value: 'icn',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Сумма (РУБ)',
					value: 'value',
					align: 'center',
					filterable: true,
					filterType: 'number',
					filterValue: {
						from: '',
						to: ''
					},
				},
				{
					text: 'Статус',
					value: 'status',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Действия',
					value: 'actions',
					align: 'center',
					filterable: false
				},
			],
			data: [],
			highlight: [],
			poolCopy: [],
			loading: false,
			loadedAll: false,
			submitLoading: false,
			filter: false,
			search: '',
			dialog: {
				show: false,
				index: 0,
				valid: false,
				new: false,
				loading: false,
				month: '',
				item: {
					value: 0,
					year: '',
					mon: '',
					month: '',
					dc: 0,
					ic: 0,
					comment: '',
				}
			},
			rules: {
	          	required: value => value !== "" || 'Обязательно'
	        },
			dc: [],
			ic: [],
			dcLoaded: false,
			expanded: [],
		}),
		computed: {
			pool() {
				return this.data.filter(item => item.statusText == 'Draft')
			},
			poolTotal() {
				return toStr(this.pool.reduce((acc, cur) => acc + toNum(cur.value), 0))
			},
			poolRevenueTotal() {
				return toStr(this.pool.reduce((acc, cur) => (cur.ic > 3000 && cur.ic < 4000) ? acc + toNum(cur.value) : acc, 0))
			},
			poolExpensesTotal() {
				return toStr(this.pool.reduce((acc, cur) => (cur.ic > 5000 && cur.ic < 7000) ? acc + toNum(cur.value) : acc, 0))
			},
			poolValid() {
				return this.poolTotal == '0.00' && this.poolRevenueTotal == '0.00' && this.poolExpensesTotal == '0.00'
			},
			poolYear() {
				if (this.pool.length) return this.pool[0].year
				else return undefined
			},
			poolMon() {
				if (this.pool.length) return this.pool[0].mon
				else return undefined
			},
			total() {
				return this.data.reduce((acc, cur) => toStr(toNum(acc) + toNum(cur.value)), 0)
			},
			filtersApplied() {
				return Object.keys(this.filters).length > 1
			},
			filters() {
				let filters = {
					search: this.search
				}

				this.headers.forEach(header => {
					if (header.filterable) {
						if (header.filterType == 'text' && header.filterValue) {
							filters[header.value] = header.filterValue
						}
						else if (header.filterType == 'date'
							&& (
								header.filterValue.fromDate
								|| header.filterValue.toDate
							)
						) {
							filters[header.value] = header.filterValue
						}
						else if (header.filterType == 'number'
							&& (
								header.filterValue.from
								|| header.filterValue.to
							)
						) {
							filters[header.value] = header.filterValue
						}
					}
				})
				return filters
			},
		},
		created() {
			// console.log('Corrections created')
			this.throttledLoadData = _.throttle(this.loadData, 1000)
			this.debouncedLoadData = _.debounce(this.loadData, 1000)
			this.loadData()
		},
		mounted() {
			window.onscroll = () => {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 500
				if (scrolled) this.throttledLoadData()
			}
		},
		watch: {
			filters: {
				handler: function () {
					if (this.pool.length) {
						this.poolCopy = _.cloneDeep(this.pool)
					}

					this.data = []
					this.loadedAll = false
					this.debouncedLoadData()
				},
				deep: true
			},
			hotelCode(val) {
				this.data = []
				this.loadedAll = false
				this.loadData()
			}
		},
		methods: {
			clickRow (row) {
				if (row.statusText == 'Draft') return

				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					this.expanded = []
					this.expanded.push(row)
				}
			},
			isExpanded (row) {
				return this.expanded.indexOf(row) >= 0
			},
			showFilter () {
				this.filter = !this.filter
				this.headers.forEach(header => {
					if (header.filterable) {
						if (header.filterType == 'text') {
							header.filterValue = ''
						}
						else if (header.filterType == 'number') {
							header.filterValue.from = ''
							header.filterValue.to = ''
						}
					}
				})
			},
			loadData () {
				if (!this.loadedAll && !this.loading) {
					this.loading = true

					api.post('reserves/get_corrections', {
						hotelCode: this.hotelCode,
						offset: this.data.length,
						filters: this.filters
					})
					.then(response => {
						// console.log('loadData Response', response.data.data[0].id, response.data.data[response.data.data.length - 1].id)

						if (this.poolCopy.length) {
							this.data.push(...this.poolCopy)
							this.poolCopy = []
						}

						response.data.data.forEach(r => this.data.push(r))
						// this.data.forEach(item => item.highlight = false)
						this.loadedAll = response.data.all
						this.loading = false

						// для отладки
						// this.copy(this.data[0])
						// setTimeout(() => this.add(), 1000)
						// setTimeout(() => this.copy(this.data[1]), 1500)
						// setTimeout(() => this.add(), 2000)

					}, error => {})
				}
			},
			getDc() {
				if (!this.dcLoaded) {
					api.post('common/get_dc', {
						pl: false,
						mult: false,
						nameFormat: 'id: rusName / engName'
					})
					.then(response => {

						this.dc = response.data.data
						this.dcLoaded = true

					}, error => {})
				}
			},
			getIc() {
				api.post('common/get_ic', {
					dc: this.dialog.item.dc,
					mult: false,
					open_to_input: true,
					nameFormat: 'code: rus_name / eng_name'
				})
				.then(response => {
					this.ic = response.data.data
				}, error => {})
			},
			newEntry() {
				this.getDc()
				this.dialog.index = 0
				this.dialog.new = true
				this.dialog.item = {
					id: 0,
					dc: '',
					ic: '',
					value: '',
					month: new Date().toISOString().substr(0, 7),
					comment: '',
				}

				if (this.poolYear && this.poolMon) {
					this.dialog.item.year = this.poolYear
					this.dialog.item.mon = this.poolMon
					this.dialog.item.month = this.dialog.item.year + '-' + this.dialog.item.mon.padStart(2, '0')
				}

				this.dialog.show = true
				if (this.$refs.f !== undefined) {
					this.$refs.f.resetValidation()
				}
			},
			copy(item) {
				this.getDc()
				this.dialog.index = 0
				this.dialog.new = true
				this.dialog.item.value = item.value
				this.dialog.item.comment = item.comment
				this.dialog.item.year = item.year
				this.dialog.item.mon = item.mon
				this.dialog.item.dc = item.dcn.split(' ')[0]
				this.dialog.item.ic = item.icn.split(' ')[0]

				if (this.poolYear && this.poolMon) {
					this.dialog.item.year = this.poolYear
					this.dialog.item.mon = this.poolMon
				}
				this.dialog.item.month = this.dialog.item.year + '-' + this.dialog.item.mon.padStart(2, '0')

				this.getDc()
				this.getIc()

				if (this.$refs.f !== undefined) {
					this.$refs.f.validate()
				}

				this.dialog.show = true
			},
			del(item) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Удаление строки',
					message: 'Удалить строку: <br><br> - '
						+ item.year + '-' + item.mon.padStart(2, '0') + '<br> - '
						+ item.dcn + '<br> - ' + item.icn
						+ '<br> - ' + item.value
						+ ' руб.<br><br>?'
				})
				.then(confirm => {
					if (confirm) {
						let index = this.data.indexOf(item)

						this.data.splice(index, 1)
					}
				})
			},
			delCorrection(item) {
				let ids = []
				let index = 0

				this.data.forEach((el, i) => {
					if (el.reportedAtUnix == item.reportedAtUnix) {
						ids.push(el.id)
						if (!index) index = i
					}
				})

				this.$store.dispatch('dialogConfirm', {
					title: 'Удаление коррекции',
					message: 'Коррекция может быть удалена только полностью.<br>'
						+ 'Будут удалены ' + ids.length + ' строк.<br><br>'
						+ 'Это действие необратимо. Вы уверены?'
				})
				.then(confirm => {
					if (confirm) {
						api.post('reserves/del_correction', {
							ids: ids
						})
						.then(response => {

							this.data.splice(index, ids.length)

						}, error => {})

					}
				})
			},
			add() {
				if (!this.dialog.valid) return

				this.dialog.loading = true

				let item = this.dialog.item
				let date = new Date(item.month)
				let year = String(date.getFullYear())
				let mon = String(date.getMonth() + 1)

				if (this.poolYear && this.poolMon) {
					if (this.poolYear != year || this.poolMon != mon) {
						this.$store.dispatch('dialogNotify', {
							title: 'Неверный период',
							message: 'Коррекция может быть произведена только в рамках одного периода'
						})
						return
					}
				}

				let dcn = item.dc + ' ' + this.dc.find(el => el.code == item.dc).name.split(' / ')[1]
				let icn = item.ic + ' ' + this.ic.find(el => el.code == item.ic).name.split(' / ')[1]

				this.data.unshift({
					year: year,
					mon: mon,
					dc: item.dc,
					ic: item.ic,
					dcn: dcn,
					icn: icn,
					value: item.value,
					comment: item.comment,
					statusText: 'Draft',
				})

				this.dialog.show = false
				this.dialog.loading = false
			},
			submit() {
				if (!this.poolValid) return

				this.submitLoading = true

				api.post('reserves/add_correction', {
					items: this.pool,
					hotelCode: this.hotelCode,
				})
				.then(response => {

					this.pool.forEach((item, i) => {
						item.id = response.data.ids[i]
						item.reportedAt = response.data.reportedAt
						item.reportedAtUnix = response.data.reportedAtUnix
						item.reportedBy = response.data.reportedBy
						item.status = response.data.status
						item.statusText = response.data.statusText
					})

					this.submitLoading = false

				}, error => {
					this.submitLoading = false
				})
			},
			clear() {

				this.$store.dispatch('dialogConfirm', {
					title: 'Сбросить коррекцию',
					message: 'Будут удалены ' + this.pool.length + ' строк. Вы уверены?'
				})
				.then(confirm => {
					if (confirm) {
						this.data.splice(0, this.pool.length)
					}
				})
			},
			edit(item) {
				this.dialog.index = this.data.indexOf(item)
				this.dialog.new = false

				this.dialog.item.value = item.value
				this.dialog.item.comment = item.comment
				this.dialog.item.dc = item.dcn.split(' ')[0]
				this.dialog.item.ic = item.icn.split(' ')[0]
				this.dialog.item.year = item.year
				this.dialog.item.mon = item.mon
				this.dialog.item.month = this.dialog.item.year + '-' + this.dialog.item.mon.padStart(2, '0')

				this.getDc()
				this.getIc()

				if (this.$refs.f !== undefined) {
					this.$refs.f.validate()
				}

				this.dialog.show = true
			},
			close() {
				this.dialog.show = !this.dialog.show
			},
			save() {
				if (!this.dialog.valid) return

				let item = this.dialog.item
				let date = new Date(item.month)
				let year = String(date.getFullYear())
				let mon = String(date.getMonth() + 1)

				if (this.poolYear && this.poolMon) {
					if (this.poolYear != year || this.poolMon != mon) {
						this.$store.dispatch('dialogNotify', {
							title: 'Неверный период',
							message: 'Коррекция может быть произведена только в рамках одного периода'
						})
						return
					}
				}

				let dcn = item.dc + ' ' + this.dc.find(el => el.code == item.dc).name.split(' / ')[1]
				let icn = item.ic + ' ' + this.ic.find(el => el.code == item.ic).name.split(' / ')[1]

				this.data[this.dialog.index].year = item.year
				this.data[this.dialog.index].mon = item.mon
				this.data[this.dialog.index].dc = item.dc
				this.data[this.dialog.index].ic = item.ic
				this.data[this.dialog.index].dcn = dcn
				this.data[this.dialog.index].icn = icn
				this.data[this.dialog.index].comment = item.comment
				this.data[this.dialog.index].value = item.value

				this.dialog.show = false

			},
			tdClass(statusText) {
				return statusText == 'Draft' ? 'blue-grey lighten-4' : ''
			},
			mouseover(item) {
				if (!item.reportedAtUnix) return

				this.data.forEach(el => {
					if (el.reportedAtUnix == item.reportedAtUnix) {
						this.highlight.push(el.id)
					}
				})
			},
			mouseleave(item) {
				if (!item.reportedAtUnix) return

				this.highlight = []
			},
		}
	}
</script>
